import React from 'react'
import { Box, Grid, Typography } from '@mui/material'

import Anchor from '@ecm/ui/element/Anchor'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'

type IconInfoBlockProps = {
  header: string
}

type ContentFeatureProp = {
  heading: string
  icon: string
}

const ContentFeatures = [
  { heading: 'Convenient junk mail filtering', icon: 'mail' },
  { heading: 'Free secured shredding services', icon: 'paper-shredding' },
  { heading: '30 days of physical letter storage', icon: 'banker-box' },
  { heading: 'Your choice of address', icon: 'location-pin' },
]

const IconInfoBlock = ({ header }: IconInfoBlockProps) => (
  <Box
    textAlign="center"
    sx={{
      background: `linear-gradient(180deg, ${Color.smoke.lightest} 69.27%, rgba(255, 255, 255, 0) 100%)`,
      paddingX: { sm: '6em', xs: '1em' },
      paddingY: { sm: '4em', xs: '2em' },
    }}
  >
    <Typography variant="h3" component="h2" mb="0.75em">
      {header}
    </Typography>
    <Grid
      container
      m="0 auto"
      p={{ lg: '5em 4em', md: '3em 2em' }}
      flexWrap="nowrap"
      borderRadius="16px"
      alignItems="center"
      bgcolor={Color.white.normal}
      flexDirection={{ md: 'row', xs: 'column' }}
      maxWidth="lg"
    >
      {ContentFeatures.map(({ heading, icon }: ContentFeatureProp) => (
        <Box textAlign="center" mb={{ md: '0', sm: '2em', xs: '1em' }} px="1.5em" key={heading}>
          <CloudflareImage src={`/images/icon/${icon}.svg`} width={72} height={72} />
          <Typography variant="h6" component="h3">
            {heading}
          </Typography>
        </Box>
      ))}
    </Grid>
    <Anchor href="/pricing/detail" my="1em" caret>
      See Detailed Pricing
    </Anchor>
  </Box>
)

export default IconInfoBlock
